import React from 'react';
import pic1 from "../../asset/image/pic1.jpg"
import pic2 from "../../asset/image/staffmng.JPG"
import pic3 from "../../asset/image/study easy javascript project.JPG"
import pic4 from "../../asset/image/ginai.JPG"
import pic5 from "../../asset/image/dhuyenin.JPG"


const Blog = () => {
    return (
        <div>
            <section className="dark:bg-gray-800 dark:text-gray-100">
                <div className="container max-w-6xl p-6 mx-auto space-y-6 sm:space-y-12">
                    <a rel="noopener noreferrer" href="#" className="block max-w-sm gap-3 mx-auto sm:max-w-full group hover:no-underline focus:no-underline lg:grid lg:grid-cols-12 dark:bg-gray-900">
                        <img src={pic1} alt="" className="object-cover w-full h-64 rounded sm:h-96 lg:col-span-7 dark:bg-gray-500" />
                        <div className="p-6 space-y-2 lg:col-span-5">
                          <a href="https://alormela.org/images/banners/2022/05/Ramadan_Calendar_Sheheri-Ifter_Time_Table_Year-2023_Hijri-1444.jpg?ezimgfmt=rs:950x1336/rscb4/ng:webp/ngcb4"><h5 className='text-3xl text-green-400'>মাহে রমজান ২০২৩, হিজরী ১৪৪৪, সেহরী ও ইফতারের সময়সূচি <span className='text-3xl text-sky-600'>এই লিঙ্কে</span></h5></a>    <span className="text-xs dark:text-gray-400">March 23, 2023</span>
                            <p>রমজান এসেছে.</p>
                        </div>
                    </a>
                    <div className="grid justify-center grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                        <a rel="noopener noreferrer" href="http://dhuenin.com/" className="max-w-sm mx-auto group hover:no-underline focus:no-underline dark:bg-gray-900">
                            <img role="presentation" className="object-cover w-full rounded h-44 dark:bg-gray-500" src={pic5} />
                            <div className="p-6 space-y-2">
                                <h3 className="text-2xl font-semibold group-hover:underline group-focus:underline">Dhuedei</h3>
                                <span className="text-xs dark:text-gray-400">March 23, 2023</span>
                                <p>Its my office Project</p>
                                <p>MY Role Is front end design and Impliment Service page api part and design ,</p>
                                <p>Order page api and full page work dashboard one module</p>
                            </div>
                        </a>
                       
                        <a rel="noopener noreferrer" href="https://legendary-blini-11aaed.netlify.app/" className="max-w-sm mx-auto group hover:no-underline focus:no-underline dark:bg-gray-900 hidden sm:block">
                            <img role="presentation" className="object-cover w-full rounded h-44 dark:bg-gray-500" src={pic2} />
                            <div className="p-6 space-y-2">
                                <h3 className="text-2xl font-semibold group-hover:underline group-focus:underline">Staff Management System</h3>
                                <span className="text-xs dark:text-gray-400">March 22, 2023</span>
                                <p>Its A Staff management System, Staff Are added ,modified and deleted,I use VueJs,Vuetify for Design and Store Management System In vuex.
                                    Its a RND and Interview Assesment Project.I Am Pass In This Assesment.
                                     </p>
                            </div>
                        </a>
                        <a rel="noopener noreferrer" href="https://warm-fox-610db3.netlify.app/" className="max-w-sm mx-auto group hover:no-underline focus:no-underline dark:bg-gray-900 hidden sm:block">
                            <img role="presentation" className="object-cover w-full rounded h-44 dark:bg-gray-500" src={pic3} />
                            <div className="p-6 space-y-2">
                                <h3 className="text-2xl font-semibold group-hover:underline group-focus:underline">Easy Study</h3>
                                <span className="text-xs dark:text-gray-400">March 23, 2023</span>
                                <p>Its A React and Javascript based project .Count Study Timne and find out break time</p>
                                
                            </div>
                        </a>
                        <a rel="noopener noreferrer" href="https://geniousvideoai.netlify.app/" className="max-w-sm mx-auto group hover:no-underline focus:no-underline dark:bg-gray-900 hidden sm:block">
                            <img role="presentation" className="object-cover w-full rounded h-44 dark:bg-gray-500" src={pic4} />
                            <div className="p-6 space-y-2">
                                <h3 className="text-2xl font-semibold group-hover:underline group-focus:underline">Genious AI</h3>
                                <span className="text-xs dark:text-gray-400">March 23, 2023</span>
                                <p>Its A reactJs project use Tailwind css ,custom css Its mainly design Task for a Interview.I added Night Mood in this project and Mobile Responsive</p>
                            </div>
                        </a>
                    </div>
                    <div className="flex justify-center">
                        <button type="button" className="px-6 py-3 text-sm rounded-md hover:underline dark:bg-gray-900 dark:text-gray-400">Load more posts...</button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Blog;